import { gql } from "@apollo/client";

// 🔹 GET ALL EVENTS
// Closed events are now returned so the and separate e_status column can render safely.
export const GET_ALL_EVENTS = gql`
  query GetAllEvents(
    $limit: Int = 50
    $offset: Int = 0
    $orderBy: [events_order_by!]
    $searchText: String = "%%"
  ) {
    events(
      where: {
        _and: [
          {
            _or: [
              { e_name: { _ilike: $searchText } }
              { e_brand_name: { _ilike: $searchText } }
            ]
          }
          { e_deleted_at: { _is_null: true } }
        ]
      }
      order_by: $orderBy
      limit: $limit
      offset: $offset
    ) {
      e_id
      e_name
      e_brand_name
      e_date
      e_date_time_zone
      e_is_active
      e_status
      e_platform_name
      e_state
      e_address
      e_city
      e_time
      e_time_zone
      event_categories(limit: 1) {
        league_category {
          league {
            l_name
          }
        }
      }
    }
    events_aggregate(
      where: {
        _and: [
          {
            _or: [
              { e_name: { _ilike: $searchText } }
              { e_brand_name: { _ilike: $searchText } }
            ]
          }
          { e_deleted_at: { _is_null: true } }
        ]
      }
      limit: 50
    ) {
      aggregate {
        count
      }
    }
  }
`;

// 🔹 NEW: Close Event — updates ONLY e_status. Does NOT touch e_is_active.
export const UPDATE_EVENT_STATUS_ONLY = gql`
  mutation UpdateEventStatusOnly($e_id: uuid!, $e_status: String!) {
    update_events_by_pk(
      pk_columns: { e_id: $e_id }
      _set: { e_status: $e_status }
    ) {
      e_id
      e_status
      e_is_active
      e_name
    }
  }
`;

// 🔹 UPDATE EVENT STATUS
export const UPDATE_EVENT_STATUS = gql`
  mutation UpdateEventStatus($e_id: uuid!, $e_is_active: Boolean!, $e_status: String!) {
    update_events_by_pk(
      pk_columns: { e_id: $e_id }
      _set: { e_is_active: $e_is_active, e_status: $e_status }
    ) {
      e_id
      e_is_active
      e_status
      e_name
    }
  }
`;

// 🔹 UPDATE EVENT
export const UPDATE_EVENT = gql`
  mutation UpdateEvent($e_id: uuid!, $eventData: events_set_input!) {
    update_events_by_pk(pk_columns: { e_id: $e_id }, _set: $eventData) {
      e_id
      e_name
      e_date
      e_time
      e_is_active
    }
  }
`;

// 🔹 ADD NEW EVENT
export const ADD_EVENT = gql`
  mutation AddEvent($eventInput: events_insert_input!) {
    insert_events_one(object: $eventInput) {
      e_id
      e_name
      e_date
      e_city
      e_state
      e_address
      e_platform_name
      e_is_active
      e_time
      e_status
    }
  }
`;

export const GET_ALL_LEAGUES = gql`
  query GetAllLeagues {
    leagues(
      where: {
        l_is_active: { _eq: true }
        l_deleted_at: { _is_null: true }
      }
      order_by: { l_name: asc }
    ) {
      l_id
      l_name
      l_type
      league_categories(
        where: {
          lc_deleted_at: { _is_null: true }
          lc_is_active: { _eq: true }
        }
        order_by: { lc_name: asc }
      ) {
        lc_id
        lc_name
        lc_abbrev
        lc_ticketmaster_name
        lc_alternate_name
        lc_market_name
      }
    }
  }
`;
// 🔹 ADD EVENT CATEGORY (to link event with league)
export const ADD_EVENT_CATEGORY = gql`
  mutation AddEventCategory($eventCategoryInput: event_categories_insert_input!) {
    insert_event_categories_one(object: $eventCategoryInput) {
      e_id
      lc_id
      ec_is_home
    }
  }
`;

export const INSERT_CONCERT_ARTIST_CATEGORY = gql`
  mutation InsertConcertArtistCategory(
    $l_id: uuid!
    $lc_name: String!
    $lc_ticketmaster_name: String!
    $lc_category_ref_id: String!
  ) {
    insert_league_categories_one(
      object: {
        l_id: $l_id
        lc_name: $lc_name
        lc_ticketmaster_name: $lc_ticketmaster_name
        lc_category_ref_id: $lc_category_ref_id
        lc_team_type: Professional
        lc_is_active: true
        lc_alternate_name: []
        lc_brand_name: ""
        lc_market_name: ""
      }
    ) {
      lc_id
      lc_name
    }
  }
`;

// 🔹 SEARCH VENUES (for autocomplete)
export const SEARCH_VENUES = gql`
  query SearchVenues($searchText: String = "%%") {
    events(
      where: {
        _and: [
          { e_address: { _ilike: $searchText } }
          { e_deleted_at: { _is_null: true } }
        ]
      }
      distinct_on: e_address
      order_by: { e_address: asc }
      limit: 10
    ) {
      e_address
    }
  }
`;

// 🔹 DELETE EVENT (if you need it)
export const DELETE_EVENT = gql`
  mutation DeleteEvent($e_id: uuid!) {
    delete_events_by_pk(e_id: $e_id) {
      e_id
      e_name
    }
  }
`;